import { useState } from "react";
import { LayoutGrid, Users, FileText, CreditCard, ShieldHalf, Lock, ScrollText, KeyRound } from "lucide-react";
import api from "@/lib/api";
import Overview from "./panels/Overview";
import UsersPanel from "./panels/UsersPanel";
import ReportsPanel from "./panels/ReportsPanel";
import TransactionsPanel from "./panels/TransactionsPanel";
import StaffPanel from "./panels/StaffPanel";
import AuditPanel from "./panels/AuditPanel";
import ChangePasswordModal from "./ChangePasswordModal";

const TABS = [
  ["overview", "Overview", LayoutGrid],
  ["users", "Customers", Users],
  ["reports", "Reports", FileText],
  ["transactions", "Payments", CreditCard],
  ["staff", "Staff", ShieldHalf],
  ["audit", "Audit log", ScrollText],
];

export default function AdminDashboard({ session, onLock }) {
  const [tab, setTab] = useState("overview");
  const [showCp, setShowCp] = useState(false);
  const adminOnly = ["staff", "audit"];
  const tabs = session.role === "admin" ? TABS : TABS.filter((t) => !adminOnly.includes(t[0]));
  const lock = async () => { try { await api.post("/admin/lock"); } catch {} onLock(); };

  return (
    <div className="min-h-screen bg-fieldstone" data-testid="admin-dashboard">
      <style>{`.td{padding:0.7rem 1rem;color:#1E2A35}.icon-btn{display:inline-grid;place-items:center;width:30px;height:30px;border-radius:8px;color:#5A6B78}.icon-btn:hover{background:#EDEBE7}`}</style>
      <header className="bg-[#101820] text-white sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-5 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 rounded-lg bg-[#E07B2A] grid place-items-center"><ShieldHalf size={16} /></div>
            <span className="font-extrabold tracking-tight">MTR Console</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-[12px] text-white/70 hidden sm:block">{session.email} · {session.role}</span>
            <button onClick={() => setShowCp(true)} className="flex items-center gap-1.5 text-[12px] font-semibold text-white/90 hover:text-white" data-testid="admin-change-password">
              <KeyRound size={14} /> Password
            </button>
            <button onClick={lock} className="flex items-center gap-1.5 text-[12px] font-semibold text-white/90 hover:text-white" data-testid="admin-lock">
              <Lock size={14} /> Lock
            </button>
          </div>
        </div>
        <nav className="max-w-7xl mx-auto px-5 flex gap-1 overflow-x-auto">
          {tabs.map(([key, label, Icon]) => (
            <button key={key} onClick={() => setTab(key)}
              className={`flex items-center gap-2 px-3.5 py-2.5 text-[13px] font-semibold border-b-2 whitespace-nowrap transition-colors ${tab === key ? "border-[#E07B2A] text-white" : "border-transparent text-white/60 hover:text-white"}`}
              data-testid={`admin-tab-${key}`}>
              <Icon size={15} /> {label}
            </button>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-5 py-6">
        {tab === "overview" && <Overview />}
        {tab === "users" && <UsersPanel />}
        {tab === "reports" && <ReportsPanel />}
        {tab === "transactions" && <TransactionsPanel />}
        {tab === "staff" && session.role === "admin" && <StaffPanel />}
        {tab === "audit" && session.role === "admin" && <AuditPanel />}
      </main>
      {showCp && <ChangePasswordModal onClose={() => setShowCp(false)} />}
    </div>
  );
}
